// HOOKS
import useModal from "../../../hooks/other/useModal.other.hook";
// COMPONENTS
import CreateOrderedPartModal from "../../modals/parts/createOrderedPart.part.modal";

const CreateOrderedPartButton = ({ onClose = () => {} }) => {
  const { isShowing, open, close } = useModal();

  const closeModal = () => {
    // Run onClose function
    onClose();
    // Close modal
    close();
  };

  return (
    <>
      <CreateOrderedPartModal isOpen={isShowing} onClose={closeModal} />
      <button
        onClick={open}
        className="shadow active:skew-y-0 hover:skew-y-3 shadow-secondary font-ubuntuBold hover:bg-secondary px-4 py-2 rounded text-white bg-primary"
      >
        Order Part
      </button>
    </>
  );
};

export default CreateOrderedPartButton;
